/* eslint-disable react/jsx-props-no-spreading */
import {useTranslation} from 'react-i18next';
import {useMutation} from '@tanstack/react-query';
import CustomModalHeader from 'components/modal/customModalHeader';
import GroupButton from 'components/button/groupButton';
import {toast} from 'react-toastify';
import {checkPermission} from 'utils/utils';
import useUser from 'hooks/useUser';
import {Label, Modal, Table, TextInput, Tooltip} from 'flowbite-react';
import {yupResolver} from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import {useForm} from 'react-hook-form';
import {useEffect, useRef, useState} from 'react';
import {themModal} from 'utils/theme';
import '../../form/styles.scss';
import './stockModal.scss';
import {locationSelector, orgSelector, userSelector} from 'redux/selectors';
import '../purchaseOrderModal/purchaseOrderModal.scss';
import {useSelector} from 'react-redux';
import {getItemsByFilter} from 'api/itemApi';
import {createStock, getStocksByFilter} from 'api/stockApi';
import {cloneDeep, concat} from 'lodash';
import {pageType, permissionKeys, sortByTypeType, defaultpageCount, apiStatus} from 'utils/constants';
import EmptyState from 'components/commonComponent/emptyState';
import GroupButtonWithIcons from 'components/button/buttonGroupWithIcons';
import {HiOutlinePlus, HiOutlineTrash} from "react-icons/hi";
import MultiSelect from 'components/select/index'
import {reconcileStockTypes} from 'utils/proptypes';
import {v4 as uuidv4} from 'uuid';
import cn from 'classnames';
import SpinnerComponent from 'components/spinner';
import { getReasonsByFilter } from 'api/reasonApi';

type reconcileManuallyModalProps = {
    openModalManually: boolean,
    setOpenModalManually: Function,
    headerTitle?: string,
    subHeaderTitle?: string,
    targetData?: any,
    isEdit: boolean,
    queryClient?: any,
    setCurrentPage?: any,
    currentPage?: number,
};
const ReconcileManuallyModal = (props: reconcileManuallyModalProps) => {
    const {
        openModalManually,
        isEdit,
        setOpenModalManually,
        headerTitle,
        subHeaderTitle,
        targetData,
        currentPage,
        queryClient,
        setCurrentPage
    } = props;
    const {WRITE_STOCK, PLATFORM_ADMIN} = permissionKeys;
    const [file, setFile] = useState(null);
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isDisabledSave, setIsDisabledSave] = useState(false);
    const [tempData, setTempData] = useState([]);
    const [itemTypeOptions, setItemTypeOptions] = useState([{label: '...', value: ''}]);
    const [selectedItem, setSelectedItem] = useState([]);
    const [selectedReason, setSelectedReason] = useState([]);
    const [errorMessages, setErrorMessages] = useState([]);
    const {fetchCurrentUser} = useUser();
    const [t] = useTranslation();
    const {userInfo} = useSelector(userSelector);
    const rootRef = useRef(null);
    const [error, setErrors] = useState(false);
    const [errorHandleItem, setErrorHandleItem] = useState(false);
    const {organizationId} = useSelector(orgSelector);
    const {locationId} = useSelector(locationSelector);
    const itemEmpty = require('../../../assets/image/svg/Emptys.svg').default || '';
    const isWriteItem = checkPermission(userInfo, pageType.LOCATION, [WRITE_STOCK], organizationId);
    const [reasonForDiscrepencyOptions, setReasonForDiscrepencyOptions] = useState([{label: '...', value: ''}]);
    const [reasonForDiscrepencys, setReasonForDiscrepencys] = useState([]);
    const pageCountDefault = 1000;

    const ValidateSchema = Yup.object().shape({
        name: Yup.string().required(t('userManagementPage.requiredField')).max(150, t('locationModal.maxLength150')),
    });

    const hookForm = useForm({
        mode: "onChange",
        resolver: yupResolver(ValidateSchema)
    });

    const {
        register,
        handleSubmit,
        setValue,
        clearErrors,
        setError,
        reset,
        getValues,
    } = hookForm;

    useEffect(() => {
        const combinedArray = tempData.reduce((acc: any, current: any) => {
            const existingItem = acc.find((item: any) => item.itemId === current.itemId);
            if (existingItem) {
                if (existingItem.errors) {
                    acc.push(current);
                } else {
                    existingItem.quantityOnHand += current.quantityOnHand;
                }
            } else {
                acc.push(current);
            }
            return acc;
        }, []);
        setData(combinedArray);

        // eslint-disable-next-line
    }, [tempData])

    const fetchItems = async () => {
        let listTemps: any = [];
    
        try {
          const filterParams = {
            limit: pageCountDefault,
            sortByType: sortByTypeType.DESC,
            organizationId,
            locationId,
            isActive: true,
          };
    
          const res = await getItemsByFilter({ ...filterParams, page: 0 });
          const totalCount = res?.data?.totalEntities || 0;
    
          if (totalCount === 0) {
            setItemTypeOptions([]);
            return;
          }
    
          listTemps = res?.data?.entities || [];
    
          const pageBreak = Math.ceil(totalCount / pageCountDefault);
    
          for (let index = 1; index < pageBreak; index++) {
            const resPage = await getItemsByFilter({ ...filterParams, page: index });
            listTemps = [...listTemps, ...(resPage?.data?.entities || [])];
          }
    
          const newOptions = listTemps.map((item: any) => ({
            label: item.name,
            value: item.id,
          }));
    
          setItemTypeOptions(newOptions);
        } catch (error) {
          console.error('Error fetching items:', error);
          setItemTypeOptions([]);
        } finally {
          
        }
      };

    useEffect(() => {
        fetchItems();

        getReasonsByFilter({page: 0, limit: pageCountDefault, sortByType: sortByTypeType.DESC, organizationId, isActive: true}).then(res => {
            const newOption = res?.data?.entities?.map((i: any) => ({label: i.name, value: i.id}));
            setReasonForDiscrepencyOptions(newOption);
            setReasonForDiscrepencys(res?.data?.entities);
        })
        // eslint-disable-next-line
    }, []);

    const handleAddAndUpdateStock = async (payload: any) => {
        setIsDisabledSave(true);
        const errorRequired = [];
        for (let index = 0; index < payload.length; index++) {
            const element = payload[index];
            element.quantityOnHand = element.quantityOnHand ? parseFloat(element.quantityOnHand) : 0;
            element.adjustmentAmount = element.quantityOnHand - element.previousCount;
            if (element.itemId === '') {
                errorRequired.push(t('stockPage.requiredFieldMessage'));
            } else {
                if (element.reasonForDiscrepancy) {
                    if (element.reasonForDiscrepancy.name?.includes('Rapid') || element.reasonForDiscrepancy.name?.includes('Other')) {
                        if (element.discreprancyNotes === '') {
                            errorRequired.push(t('stockPage.requiredFieldMessage'));
                        } else {
                            if (errorHandleItem === true) {
                                errorRequired.push(t('itemPage.conflictedItem'));
                            }
                        }
                    } else {
                        if (errorHandleItem === true) {
                            errorRequired.push(t('itemPage.conflictedItem'));
                        }
                    }
                } else {
                    console.log("bugggggggg")
                    errorRequired.push(t('stockPage.requiredFieldMessage'));
                }
            }
        }

        if (errorRequired.length > 0) {
            toast.error(`${t('stockPage.requiredFieldMessage')}`);
            setIsDisabledSave(false);
        } else {
            const res = await createStock(payload);
            if (res.status >= apiStatus.SUCCESS) {
                toggleHandler();
                if (currentPage !== 0) {
                    queryClient.invalidateQueries('getStocks', {refetchActive: false}, {cancelRefetch: true});
                    setCurrentPage(0);
                } else queryClient.invalidateQueries('getStocks', {refetchActive: true}, {cancelRefetch: true});
                const message: string = t('stockPage.editSuccess');
                toast.success(message);
                fetchCurrentUser();
            } else {
                toast.error(res.data?.errors?.[0].detail);
                setIsDisabledSave(false);
            }
        }
    };

    const handleAddRow = (item: any) => {
        if (item) {
            if (item.itemId === '') {
                toast.error(`${t('stockPage.requiredFieldMessage')}`);
            } else {
                if (item.reasonforDiscrepancy === 'Rapid' || item.reasonforDiscrepancy === 'Other') {
                    if (item.discreprancyNotes === '') {
                        toast.error(`${t('stockPage.requiredFieldMessage')}`);
                    } else {
                        if (errorHandleItem === true) {
                            toast.error(`${t('itemPage.conflictedItem')}`);
                        } else {
                            addRowFunc();
                        }
                    }
                } else {
                    if (errorHandleItem === true) {
                        toast.error(`${t('itemPage.conflictedItem')}`);
                    } else {
                        addRowFunc();
                    }
                }
            }
        } else {
            addRowFunc();
        }
    };

    const addRowFunc = () => {
        const reasonForDiscrepancyDefault: any = reasonForDiscrepencys?.find((x: any) => x.isReconcileDefault === true);
        const newRow: reconcileStockTypes = {
            // Initialize the properties of the new row here
            // For example:
            id: uuidv4(),
            locationId: locationId,
            location: {id: locationId},
            itemId: '',
            item: null,
            userId: userInfo.id,
            user: {id: userInfo.id},
            previousCount: 0,
            quantityOnHand: 0,
            discreprancyNotes: '',
            reasonForDiscrepancyId: reasonForDiscrepancyDefault ? reasonForDiscrepancyDefault.id : '',
            reasonForDiscrepancy: reasonForDiscrepancyDefault ? { id: reasonForDiscrepancyDefault.id } : null
        };
        const newData: any = concat(data, newRow)
        setData(newData);
    }

    const handleDeleteRow = (id: string) => {
        const newData = data?.filter((d: any) => d.id !== id);
        setData(newData);
    };

    const mutation = useMutation(['create-update-category'], {mutationFn: handleAddAndUpdateStock});

    const toggleHandler = () => {
        setOpenModalManually(!openModalManually);
    };

    const handleChangeItem = async (id: string, option: any, field: any) => {
        const itemCheck = data.find((x: any) => x.itemId === option?.value);
        if (itemCheck) {
            setErrorHandleItem(true);
        } else {
            setErrorHandleItem(false);
        }
        const oldQuantityOnHand = data?.find((o: any) => o.id === id)?.['quantityOnHand'] || '0';
        const listContentClone = cloneDeep(data);
        const findContent: any = listContentClone?.find((item: any) => item.id === id);
        
        findContent[field] = option?.value;
        findContent['item'] = {id: option?.value};
        findContent['errors'] = undefined;
        
        const res = await getStocksByFilter({
            page: 0,
            limit: 10,
            sortByType: sortByTypeType.DESC,
            locationId,
            itemId: option?.value,
            includeZeroOrNegativeStock: true
        });
        if (res.data.entities?.length > 0) {
            findContent['previousCount'] = res.data.entities?.[0]?.quantityOnHand || 0;
        } else {
            findContent['previousCount'] = 0;
        }

        if (findContent['action']) {
            if (findContent['action'] === 'ADD') {
                findContent['quantityOnHand'] = findContent['previousCount'] + findContent['quantity'];
            } else {
                if (findContent['action'] === 'remove') {
                    findContent['quantityOnHand'] = findContent['previousCount'] - findContent['quantity'];
                } else {
                    findContent['quantityOnHand'] = findContent['quantity'];
                }
            }
        } else {
            findContent['quantityOnHand'] = oldQuantityOnHand;
        }
        setData(listContentClone);
    };

    const handleChangeReason = (id: string, option: any, field: any) => {
        const listContentClone = cloneDeep(data);
        const findContent: any = listContentClone?.find((item: any) => item.id === id);
        findContent[field] = option.value;
        findContent['reasonForDiscrepancy'] = { id: option.value };
        setData(listContentClone);
    };

    const handleChangeContentOverview = (id: string, value: any, field: any) => {
        const listContentClone = cloneDeep(data);
        const findContent: any = listContentClone?.find((item: any) => item.id === id);
        findContent[field] = value;
        setData(listContentClone);
    };

    return (
        <div ref={rootRef} className="stock-modal-manually-container">
            <Modal
                show={openModalManually}
                size="6xl"
                className="stock-modal"
                root={rootRef.current ?? undefined}
                onClose={toggleHandler}
                dismissible={false}
                theme={themModal}
            >
                <CustomModalHeader title={headerTitle} toggle={toggleHandler}/>
                <div className="text-primary text-sm font-normal text-center pb-3">{subHeaderTitle}
                </div>
                <Modal.Body theme={{base: 'flex flex-col items-center'}}>
                    <>
                        {data && data.length === 0 ?
                            (isEdit ?
                                    (isLoading ? <SpinnerComponent/> : <EmptyState buttonName=""
                                                                                   handleAddClick={false}
                                                                                   title={t('stockPage.titleImportNoResult')}
                                                                                   subtitle={t('stockPage.subTitleImportNoResult')}
                                                                                   icon={itemEmpty}
                                    />)
                                    :
                                    (<EmptyState buttonName="Add Item"
                                                 handleAddClick={isWriteItem && handleAddRow}
                                                 title={t('stockPage.titleNoItemResult')}
                                                 subtitle={t('itemPage.subTitleNoResult')}
                                                 icon={itemEmpty}
                                    />)
                            )
                            :
                            (
                                <>
                                    <Table className="reconcile-table">
                                        <Table.Head
                                            className="text-gray-900 border-b border-gray-100 border-b-2 w-full">
                                            <Table.HeadCell
                                                className="cursor-pointer bg-white font-medium text-xs item px-0 py-0 pr-0 align-bottom">
                                               <p className="item">{t('stockPage.reconcileItem')}</p>
                                            </Table.HeadCell>
                                            <Table.HeadCell
                                                className="cursor-pointer bg-white font-medium text-xs previous py-0 px-0 align-bottom">
                                                <p className="previous">{t('stockPage.previousCount')}</p>
                                            </Table.HeadCell>
                                            <Table.HeadCell
                                                className="cursor-pointer bg-white font-medium text-xs current py-0 px-0 align-bottom ">
                                                <p className="current">{t('stockPage.currentCount')}</p>
                                            </Table.HeadCell>
                                            <Table.HeadCell
                                                className="cursor-pointer bg-white font-medium text-xs reason py-0 px-0 align-bottom ">
                                                <p className="reason">{t('stockPage.reasonForDiscrepency')}</p>
                                            </Table.HeadCell>
                                            <Table.HeadCell
                                                className="cursor-pointer bg-white font-medium text-xs discrepency py-0 px-0 align-bottom ">
                                                <p className="discrepency">{t('stockPage.discrepencyNotes')}</p>
                                            </Table.HeadCell>
                                            <Table.HeadCell
                                                className=" bg-white font-medium text-xs action py-0 px-0 action">{''}</Table.HeadCell>
                                        </Table.Head>
                                        <Table.Body className={cn("", {
                                            '--overflow': data?.length > 6
                                        })}>
                                            {data.map((item: reconcileStockTypes, index) => {
                                                return (
                                                    <Table.Row key={`row-${item.id}`}
                                                               className="cursor-pointer bg-white text-sm hover:bg-gray-50 border-b border-gray-100">
                                                        {item.itemId === '' ?
                                                            (
                                                                <Table.Cell className="px-0 pr-3 py-3 item">
                                                                    <MultiSelect
                                                                        onChange={(e: any) => {
                                                                            handleChangeItem(item?.id, e, 'itemId')
                                                                        }}
                                                                        options={itemTypeOptions}
                                                                        value={itemTypeOptions.find((i: any) => i.value === item.itemId)}
                                                                        hookForm={hookForm}
                                                                        id={`item-${index}`}
                                                                        name={`item-${index}`}
                                                                        noOptionsMessage={() => t('No options')}
                                                                        closeMenuOnSelect
                                                                        isHolderLabel={false}
                                                                        className="select-item"
                                                                    />
                                                                    <div
                                                                        className={`text-red-600 text-xs font-normal mt-1 veri-modal height-16`}>{t('userManagementPage.requiredField')}</div>
                                                                </Table.Cell>
                                                            )
                                                            :
                                                            (
                                                                <Tooltip
                                                                    content={itemTypeOptions.find((i: any) => i.value === item.itemId) !== null ? itemTypeOptions.find((i: any) => i.value === item.itemId)?.label : ""}>
                                                                    <Table.Cell className="px-0 py-3 item">
                                                                        <MultiSelect
                                                                            onChange={(e: any) => {
                                                                                handleChangeItem(item?.id, e, 'itemId')
                                                                            }}
                                                                            options={itemTypeOptions}
                                                                            value={itemTypeOptions.find((i: any) => i.value === item.itemId)}
                                                                            hookForm={hookForm}
                                                                            id={`item-${index}`}
                                                                            name={`item-${index}`}
                                                                            noOptionsMessage={() => t('No options')}
                                                                            closeMenuOnSelect
                                                                            isHolderLabel={false}
                                                                            className="select-item"
                                                                        />
                                                                        {errorHandleItem === true && (<div
                                                                            className={`text-red-600 text-xs font-normal mt-1 veri-modal height-16`}>{t('itemPage.conflictedItem')}</div>)}
                                                                        {item.errors && (<div
                                                                            className={`text-red-600 text-xs font-normal mt-1 warning`}>{t('itemPage.notFoundItem').replace('%UPC%', item.upc || '')}</div>)}
                                                                    </Table.Cell>
                                                                </Tooltip>
                                                            )
                                                        }
                                                        <Table.Cell key={item?.previousCount}
                                                                    className="py-3 px-0 previous">
                                                            <Label>{item?.errors ? 0 : item?.previousCount}</Label>
                                                        </Table.Cell>
                                                        <Table.Cell className="py-3 px-0 current">
                                                            <TextInput
                                                                type="number"
                                                                name={`quantityOnHand-${index}`}
                                                                value={item?.errors ? 0 : item?.quantityOnHand}
                                                                onChange={(e: any) => {
                                                                    handleChangeContentOverview(item?.id, e.target.value, 'quantityOnHand')
                                                                }}
                                                            />
                                                        </Table.Cell>
                                                        <Tooltip
                                                            content={reasonForDiscrepencyOptions.find((i: any) => i.value === item.reasonForDiscrepancyId) !== null ? reasonForDiscrepencyOptions.find((i: any) => i.value === item.reasonForDiscrepancyId)?.label : ""}>
                                                            <Table.Cell className="py-3 px-0 reason">
                                                                <MultiSelect
                                                                    onChange={(e: any) => {
                                                                        handleChangeReason(item?.id, e, 'reasonForDiscrepancyId')
                                                                    }}
                                                                    options={reasonForDiscrepencyOptions}
                                                                    value={reasonForDiscrepencyOptions.find((r: any) => r.value === item.reasonForDiscrepancyId)}
                                                                    hookForm={hookForm}
                                                                    name={`reasonforDiscrepancy-${index}`}
                                                                    noOptionsMessage={() => t('No options')}
                                                                    closeMenuOnSelect
                                                                    isHolderLabel={false}
                                                                    className="select-reason"
                                                                />
                                                                {!item.reasonForDiscrepancy && (
                                                                <div
                                                                    className={`text-red-600 px-4 text-xs font-normal mt-1 veri-modal height-16`}>{t('userManagementPage.requiredField')}</div>)}
                                                            </Table.Cell>
                                                        </Tooltip>
                                                        <Table.Cell className="py-3 px-0 discrepency">
                                                            <TextInput
                                                                type="text"
                                                                name={`discrepancyNote-${index}`}
                                                                value={item?.discreprancyNotes}
                                                                onChange={(e: any) => {
                                                                    handleChangeContentOverview(item?.id, e.target.value, 'discreprancyNotes')
                                                                }}
                                                                required={item.reasonForDiscrepancy?.name?.includes('Other') ? true : false}
                                                            />
                                                            {(item.reasonForDiscrepancy?.name?.includes('Rapid') || item.reasonForDiscrepancy?.name?.includes('Other')) && item.discreprancyNotes === '' && (
                                                                <div
                                                                    className={`text-red-600 text-xs font-normal mt-1 veri-modal height-16`}>{t('userManagementPage.requiredField')}</div>)}
                                                        </Table.Cell>
                                                        <Table.Cell className="py-3 px-0 action">
                                                            <GroupButtonWithIcons
                                                                className="items-center justify-center"
                                                                buttons={[
                                                                    {
                                                                        type: 'button',
                                                                        text: '',
                                                                        classType: 'white',
                                                                        icon: <HiOutlineTrash size={"20px"}/>,
                                                                        action: () => {
                                                                            handleDeleteRow(item?.id)
                                                                        },
                                                                    },
                                                                    {
                                                                        type: 'button',
                                                                        text: '',
                                                                        classType: 'white',
                                                                        icon: <HiOutlinePlus size={"20px"}/>,
                                                                        action: () => handleAddRow(item),
                                                                    },
                                                                ]}
                                                            />
                                                        </Table.Cell>
                                                    </Table.Row>
                                                )
                                            })}
                                        </Table.Body>
                                    </Table>

                                    <GroupButton
                                        className="items-center justify-center mt-6 mb-6"
                                        buttons={[
                                            {
                                                type: 'button',
                                                text: t('modal.cancel'),
                                                classType: 'white',
                                                action: () => toggleHandler(),
                                            },
                                            {
                                                type: 'button',
                                                text: t('modal.save'),
                                                classType: 'blue',
                                                action: () => {
                                                    handleAddAndUpdateStock(data)
                                                },
                                                disabled: isDisabledSave
                                            },
                                        ]}
                                    />
                                </>
                            )
                        }
                    </>
                </Modal.Body>
            </Modal>
        </div>
    );
};
export default ReconcileManuallyModal;
